import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import { Modal, Popover, Tabs } from 'antd';
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import Pagination from "../../utils/Pagination";
import { formatDateToDMY, formatTime12Hour, formatEventType } from "../../utils/tools";
import ContentLoader from "../../utils/ContentLoader";
import { useState } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ImagePreviewModal from "../../utils/ImagePreviewModal";
import { showDeleteConfirm } from "../../utils/deleteConfirm";

const { confirm } = Modal;

const TABS = [
    { key: "all",       label: "All" },
    { key: "25",        label: "10 - 25 Days" },
    { key: "50",        label: "26 - 50 Days" },
    { key: "150",       label: "51 - 150 Days" },
    { key: "200",       label: "151 - 200 Days" },
    { key: "300",       label: "201 - 363 Days" },
    { key: "completed", label: "Completed" },
];

const ReadingPlanTable = ({
    readingplan,
    page,
    setPage,
    totalPages,
    totalEntries,
    sort,
    order,
    setOrder,
    setSort,
    search,
    setSearch,
    fetchReadingPlan,
    onView,
    entriesPerPage,
    setEntriesPerPage,
    activeTab,
    setActiveTab,
    langFilter,
    setLangFilter,
    planTypeFilter,
    setPlanTypeFilter,
}) => {
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleDelete = (id) => {
        showDeleteConfirm(async () => {
            try {
                await api.delete(`/readingplan/${id}`);
                toast.success("Reading plan deleted successfully");
                fetchReadingPlan();
            } catch {
                toast.error("Failed to delete reading plan");
            }
        });
    };

    // console.log("reading plan table====>", readingplan);

    const headerConfig = [
        { key: "user_name", label: "User Name", sortable: false },
        { key: "registered_at", label: "Registered At", sortable: false },
        { key: "start_date", label: "Started At", sortable: false },
        { key: "readed", label: "Last Readed At", sortable: false },
        { key: "normalOrShuffeled", label: "Plan", sortable: false },
        { key: "plan_type", label: "Plan Type", sortable: false },
        { key: "completed_days", label: "Completed Days", sortable: false },
        { key: "pending_days", label: "Pending Days ", sortable: false },
        { key: "action", label: "Action", sortable: false }
    ];

    if (loading) return <ContentLoader />;

    return (
        <div className="card basic-data-table text-sm overflow-x-auto">
            <div className="card-header d-flex justify-content-between align-items-center global-header">

                <div className="tabs-container">
                    <Tabs
                        activeKey={activeTab}
                        onChange={(key) => {
                            setActiveTab(key);
                            setPage(1);
                        }}
                        items={TABS}
                    />
                </div>
                <div className="d-flex align-items-center gap-3">
                    {/* Refresh Icon */}

                    <Icon
                        icon="mdi:refresh"
                        width="26"
                        height="26"
                        className="ms-2 text-lg d-none d-md-inline-flex refresh-icon "
                        onClick={fetchReadingPlan}
                    />

                    <div className="search-container" style={{ gap: "10px" }}>
                        <select
                            className="form-select"
                            style={{ height: "38px", minWidth: "140px" }}
                            value={langFilter}
                            onChange={(e) => {
                                setLangFilter(e.target.value);
                                setPage(1);
                            }}
                        >
                            <option value="all">All Languages</option>
                            <option value="tn">Tamil (tn)</option>
                            <option value="en">English (en)</option>
                        </select>
                        <select
                            className="form-select"
                            style={{ height: "38px", minWidth: "150px" }}
                            value={planTypeFilter}
                            onChange={(e) => {
                                setPlanTypeFilter(e.target.value);
                                setPage(1);
                            }}
                        >
                            <option value="">All Plan Types</option>
                            <option value="6 மாதங்கள்">6 மாதங்கள்</option>
                            <option value="12 மாதங்கள்">12 மாதங்கள்</option>
                            <option value="6 Months">6 Months</option>
                            <option value="12 Months">12 Months</option>
                        </select>
                        <SearchBy
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                        />
                        {viewPermissions.includes("reader.create") && (
                            <button
                                className="btn btn-primary-600 global-add-btn"
                                type="button"
                                onClick={() => navigate("/readingplan-form")}
                            >
                                <Icon
                                    icon="fa6-regular:square-plus"
                                    className="icon text-lg line-height-1"
                                />
                                Add
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <div className="card-body card-body-modify">
                <div className="w-full overflow-x-auto">
                    {activeTab === "completed" ? (
                        <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                            <thead>
                                <tr>
                                    <th>User Name</th>
                                    <th>Email</th>
                                    <th>Plan Type</th>
                                    <th>Completed Days</th>
                                    <th>Cycle No.</th>
                                    <th>Started At</th>
                                    <th>Completed At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(readingplan) && readingplan.length > 0 ? (
                                    readingplan.map((item) => (
                                        <tr key={item.id}>
                                            <td className="d-flex align-items-center gap-2">
                                                <ImagePreviewModal
                                                    src={item.user?.avatar || "/assets/images/fall-back-church.webp"}
                                                    fallback="/assets/images/logo-profile.png"
                                                    alt={item.user?.name}
                                                    thumbWidth={50}
                                                    thumbHeight={50}
                                                />
                                                <span>{item.user?.name || "-"}</span>
                                            </td>
                                            <td>{item.user?.email || "-"}</td>
                                            <td>{item.plan_type || "-"}</td>
                                            <td>{item.completed_days ?? "-"}</td>
                                            <td>{item.cycle_number ?? "-"}</td>
                                            <td>{item.started_at ? `${formatDateToDMY(item.started_at)} ${formatTime12Hour(item.started_at)}` : "-"}</td>
                                            <td>{item.completed_at ? `${formatDateToDMY(item.completed_at)} ${formatTime12Hour(item.completed_at)}` : "-"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7} className="text-center">No completed plans found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    ) : (
                        <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                            <thead>
                                <tr>
                                    {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(readingplan) && readingplan.length > 0 ? (
                                    readingplan.map((item) => (
                                        <tr key={item.id}>
                                            <td className="d-flex align-items-center gap-2">
                                                <ImagePreviewModal
                                                    src={item.user?.avatar ? `${item.user?.avatar}` : "/assets/images/fall-back-church.webp"}
                                                    fallback="/assets/images/logo-profile.png"
                                                    alt={item.church_name}
                                                    thumbWidth={50}
                                                    thumbHeight={50}
                                                />
                                                <span>{item.user_name}</span>
                                            </td>

                                            <td>
                                                {item.created_at
                                                    ? `${formatDateToDMY(item.created_at)} ${formatTime12Hour(item.created_at)}`
                                                    : "-"}
                                            </td>

                                            <td>
                                                {item.start_date
                                                    ? `${formatDateToDMY(item.start_date)} ${formatTime12Hour(item.start_date)}`
                                                    : "-"}
                                            </td>

                                            <td>
                                                {item.readed ? `${formatDateToDMY(item.readed)} ${formatTime12Hour(item.readed)}` : "-"}
                                            </td>

                                            <td>{item.normalOrShuffeled || "-"}</td>

                                            <td>{item.plan_type || "-"}</td>

                                            <td>{item.completed_days || "-"}</td>

                                            <td>{item.remaining_days > 0 ? item.remaining_days : 0}</td>

                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    {viewPermissions.includes("reader.view") && (
                                                        <button
                                                            className="w-32-px h-32-px bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                            onClick={() => onView(item)}
                                                        >
                                                            <Icon icon="iconamoon:eye-light" />
                                                        </button>
                                                    )}
                                                    {viewPermissions.includes("reader.edit") && (
                                                        <button
                                                            className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                            onClick={() => navigate(`/readingplan-form/${item.id}`)}
                                                        >
                                                            <Icon icon="lucide:edit" />
                                                        </button>
                                                    )}
                                                    {viewPermissions.includes("reader.delete") && (
                                                        <button
                                                            className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                            onClick={() => handleDelete(item.id)}
                                                        >
                                                            <Icon icon="mingcute:delete-2-line" />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={9} className="text-center">No reading plans found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
                <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                />
            </div>
        </div>
    );
};

export default ReadingPlanTable;